import { render } from "./subjectgroups.vue?vue&type=template&id=3a1eb935&scoped=true"
import script from "./subjectgroups.vue?vue&type=script&lang=js"
export * from "./subjectgroups.vue?vue&type=script&lang=js"

import "@/assets/css/ts-table.css?vue&type=style&index=0&id=3a1eb935&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1eb935"]])

export default __exports__